import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2024DatosGenerales() {
  return <CategoryPage category="anexo30Y31Ano2024DatosGenerales" pageTitle="Datos Generales 2024" />;
}

export default Anexo30Y31Ano2024DatosGenerales;
